export enum MopCheckStatusEnum{
  Y = "Y",
  N = "N",
  X = "X",
  E = "E",
  none = ""
}